import React from 'react';
import { X } from 'lucide-react';

const RadioModal = ({ 
  setActiveModal, 
  radioData, 
  setRadioData, 
  logRadio 
}) => (
  <div className="p-6">
    <div className="flex justify-between items-center mb-4">
      <h3 className="text-lg font-semibold">
        {radioData.type === 'distress' ? '🆘 Distress Transmission' : 'Radio Traffic'}
      </h3>
      <button onClick={() => setActiveModal(null)} className="text-gray-400 hover:text-gray-600">
        <X className="h-5 w-5" />
      </button>
    </div>
    
    <div className="space-y-4">
      {radioData.type === 'distress' && (
        <div className="bg-red-50 border-l-4 border-red-400 p-3 text-sm text-red-700">
          Recording distress transmission on CH16
        </div>
      )}
      
      <div className="grid grid-cols-2 gap-3">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Channel</label>
          <input
            type="text"
            value={radioData.channel}
            onChange={(e) => setRadioData({...radioData, channel: e.target.value})}
            placeholder="16"
            className="w-full px-3 py-2 border border-gray-300 rounded-md"
          />
        </div>
        
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Type</label>
          <select
            value={radioData.type}
            onChange={(e) => setRadioData({...radioData, type: e.target.value})}
            className="w-full px-3 py-2 border border-gray-300 rounded-md"
          >
            <option value="routine">Routine</option>
            <option value="safety">Safety</option>
            <option value="urgency">Urgency (PAN)</option>
            <option value="distress">Distress (MAYDAY)</option>
          </select>
        </div>
      </div>
      
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">From</label>
        <input
          type="text"
          value={radioData.from}
          onChange={(e) => setRadioData({...radioData, from: e.target.value})}
          placeholder="e.g., Port Control, Vessel Name, VTS"
          className="w-full px-3 py-2 border border-gray-300 rounded-md"
        />
      </div>
      
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">To</label>
        <input
          type="text"
          value={radioData.to}
          onChange={(e) => setRadioData({...radioData, to: e.target.value})}
          placeholder="e.g., Our vessel, All stations"
          className="w-full px-3 py-2 border border-gray-300 rounded-md"
        />
      </div>
      
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">Message *</label>
        <textarea
          value={radioData.message}
          onChange={(e) => setRadioData({...radioData, message: e.target.value})}
          placeholder="Enter message content..."
          rows={3}
          className="w-full px-3 py-2 border border-gray-300 rounded-md"
        />
      </div>
      
      <div className="flex gap-2 pt-4">
        <button
          onClick={() => setActiveModal(null)}
          className="flex-1 px-4 py-2 border border-gray-300 rounded-lg hover:bg-gray-50"
        >
          Cancel
        </button>
        <button
          onClick={logRadio}
          disabled={!radioData.message}
          className={`flex-1 px-4 py-2 rounded-lg text-white ${
            radioData.type === 'distress' 
              ? 'bg-red-600 hover:bg-red-700' 
              : 'bg-blue-600 hover:bg-blue-700'
          } disabled:bg-gray-400`}
        >
          Log {radioData.type === 'distress' ? 'Distress' : 'Radio Traffic'}
        </button>
      </div>
    </div>
  </div>
);

export default RadioModal;